<div class="usan-forms">
  <div class="form-content-layout">
    <app-form-header></app-form-header>
  </div>
  <div class="form-content-tabs-layout" [ngClass]="{ 'form-content-tabs-layout__mobile' : isMobileDeviceSize }">
    <app-form-tabs></app-form-tabs>
  </div>
  <div class="form-content-body-layout">
    <div [ngSwitch]="formTab" class="full-width">
      <ng-container *ngSwitchCase="'contact-usan'">
      </ng-container>
      <ng-container *ngSwitchDefault>
        <app-form-sections-nav [formType]="formType" class="full-width"></app-form-sections-nav>
      </ng-container>
    </div>
  </div>
</div>